import { company } from '~/company/Company';

export const EnvConfig = {
  AWS_PAY_BASE_URL: company.envVariables.REACT_APP_AWS_PAY_BASE_URL,
  AWS_PAY_PHRASE: company.envVariables.REACT_APP_AWS_PAY_PHRASE,
  AWS_PAY_RETURN_URL: company.envVariables.REACT_APP_AWS_PAY_RETURN_URL,
  AWS_PAY_ACCESS_CODE: company.envVariables.REACT_APP_AWS_PAY_ACCESS_CODE,
  MERCHANT_IDENTIFIER: company.envVariables.REACT_APP_MERCHANT_IDENTIFIER,
};
